import _Singleton, { deferredSingletonExport } from '@/tools/singleton';
import publish from './modules/publish';
import subscribe from './modules/subscribe';
import unsubscribe from './modules/unsubscribe';
import _selectEvent from './modules/select-event';
import EventsLogger from './logger';

class EventBus {
  constructor() {
    this.eventsList = {};
    this.logger = new EventsLogger(this);
  }

  publish() {
    return publish.apply(this, arguments);
  }

  subscribe() {
    return subscribe.apply(this, arguments);
  }

  unsubscribe() {
    return unsubscribe.apply(this, arguments);
  }

  _selectEvent() {
    return _selectEvent.apply(this, arguments);
  }
}

export default deferredSingletonExport(_Singleton(EventBus), EventBus);
